import { Download, Copy, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { T } from "@/locales/tr";

const PORTRAIT = `${process.env.PUBLIC_URL || ""}/papicoo-portrait.png`;

/**
 * PostKit — bloc unifié qui apparaît sous tout contenu généré par Papicoo.
 * Affiche un aperçu du portrait + bouton "Télécharger" + "Copier le texte".
 * À utiliser systématiquement avec les publications réseaux.
 */
export default function PostKit({ text, filename = "papicoo-portrait.png", title = "Pour ta publication" }) {
  if (!text) return null;
  return (
    <div data-testid="post-kit" className="mt-5 papicoo-card p-4 sm:p-5 bg-[color:var(--papicoo-sand-deep)]/40">
      <div className="text-[10px] uppercase tracking-[0.22em] text-[color:var(--papicoo-accent)] inline-flex items-center gap-2">
        <ImageIcon size={12} /> {T("Kit publication réseaux")}
      </div>
      <div className="mt-3 flex items-start gap-4">
        <img
          src={PORTRAIT}
          alt={T("Portrait Papicoo")}
          className="w-16 h-20 sm:w-20 sm:h-24 object-cover rounded-md border border-[color:var(--papicoo-gold)] shrink-0"
        />
        <div className="flex-1 text-[13px] text-[color:var(--papicoo-text)] leading-relaxed">
          <div className="font-display text-base text-[color:var(--papicoo-ink)]">{T(title)}</div>
          <p className="text-xs text-[color:var(--papicoo-muted)] mt-1">
            {T("Utilise")} <strong>{T("cette photo officielle de Papicoo")}</strong> {T("avec ton texte sur Facebook, Instagram, TikTok, LinkedIn — c'est la signature visuelle unifiée.")}
          </p>
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <a
          data-testid="postkit-download"
          href={PORTRAIT}
          download={filename}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full papicoo-btn-gold text-xs"
        >
          <Download size={14} /> {T("Télécharger la photo")}
        </a>
        <button
          data-testid="postkit-copy-text"
          onClick={() => { navigator.clipboard.writeText(text); toast.success("Texte copié — colle-le avec la photo."); }}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[color:var(--papicoo-border)] text-xs text-[color:var(--papicoo-ink)]"
        >
          <Copy size={14} /> {T("Copier le texte")}
        </button>
      </div>
    </div>
  );
}
